module.exports = __webpack_public_path__ + "img/16581288_L.e65b36c3.png";